// src/Pages/DistrictwiseSpecialGSCompliance.jsx
import { useEffect, useState } from "react";
import { Table, Button, Spin, Alert, Space, message, Modal } from "antd";
import { ReloadOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import { autoTable } from "jspdf-autotable";
// 🔥 create this API
import {
    getCeoDistrictwiseGSCompliance,
    getBlockwiseGSComplianceCEO,  // Changed from getBlocksummaryforadmin
    getGPwiseGSComplianceCEO
} from "../api/User";

const DistrictwiseSpecialGSComplianceCEO = ({ dateFilter }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    /* -------- MAIN TABLE PAGINATION -------- */
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    /* -------- BLOCK MODAL PAGINATION -------- */
    const [blockCurrentPage, setBlockCurrentPage] = useState(1);
    const [blockPageSize, setBlockPageSize] = useState(10);

    /* -------- GP MODAL PAGINATION -------- */
    const [gpCurrentPage, setGpCurrentPage] = useState(1);
    const [gpPageSize, setGpPageSize] = useState(10);
    /* -------- Block Modal -------- */
    const [blockModalOpen, setBlockModalOpen] = useState(false);
    const [blockModalTitle, setBlockModalTitle] = useState("");
    const [blockData, setBlockData] = useState([]);
    const [blockLoading, setBlockLoading] = useState(false);

    /* -------- GP Modal -------- */
    const [gpModalOpen, setGpModalOpen] = useState(false);
    const [gpModalTitle, setGpModalTitle] = useState("");
    const [gpData, setGpData] = useState([]);
    const [gpLoading, setGpLoading] = useState(false);


    /* ================= GRAND TOTALS CALCULATION ================= */
    const mainTotals = {
        block_count: data.reduce((s, i) => s + (i.block_count || 0), 0),
        gp_count: data.reduce((s, i) => s + (i.gp_count || 0), 0),
        m1_conducted: data.reduce((s, i) => s + (i.m1_conducted || 0), 0),
        m1_updated: data.reduce((s, i) => s + (i.m1_updated || 0), 0),
        m1_quorum_yes: data.reduce((s, i) => s + (i.m1_quorum_yes || 0), 0),
        m1_quorum_no: data.reduce((s, i) => s + (i.m1_quorum_no || 0), 0),
        m2_conducted: data.reduce((s, i) => s + (i.m2_conducted || 0), 0),
        m2_updated: data.reduce((s, i) => s + (i.m2_updated || 0), 0),
        m2_quorum_yes: data.reduce((s, i) => s + (i.m2_quorum_yes || 0), 0),
        m2_quorum_no: data.reduce((s, i) => s + (i.m2_quorum_no || 0), 0),
        m3_conducted: data.reduce((s, i) => s + (i.m3_conducted || 0), 0),
        m3_updated: data.reduce((s, i) => s + (i.m3_updated || 0), 0),
        m3_quorum_yes: data.reduce((s, i) => s + (i.m3_quorum_yes || 0), 0),
        m3_quorum_no: data.reduce((s, i) => s + (i.m3_quorum_no || 0), 0),
        never_rescheduled: data.reduce((s, i) => s + (i.never_rescheduled || 0), 0),
    };



    /* ================= CLICK STYLE ================= */
    const clickStyle = {
        color: "#1677ff",
        cursor: "pointer",
        textDecoration: "underline",
        fontWeight: 500,
    };

    const numberSorter = (a, b, key) => {
        const valA = a[key] || 0;
        const valB = b[key] || 0;
        return valA - valB;
    };

    const stringSorter = (a, b, key) => {
        const valA = (a[key] || '').toString().toLowerCase();
        const valB = (b[key] || '').toString().toLowerCase();
        return valA.localeCompare(valB);
    };


    /* ================= TABLE COLUMNS ================= */
    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            width: 60,
            fixed: "left",
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
        },
        {
            title: "District",
            dataIndex: "district_name",
            width: 160,
            fixed: "left",
            align: "center",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),
        },
        {
            title: "No. of Blocks",
            dataIndex: "block_count",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'block_count'),
            render: (val, record) => (
                <span
                    onClick={() => openBlockModal(record)}
                    style={clickStyle}
                >
                    {val || 0}
                </span>
            ),
        },
        {
            title: "No. of Gram Panchayats",
            dataIndex: "gp_count",
            width: 160,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gp_count'),
            render: (val, record) => (
                <span
                    onClick={() => openGPFromDistrict(record)}
                    style={clickStyle}
                >
                    {val || 0}
                </span>
            ),
        },

        /* -------- 1st Meeting -------- */
        {
            title: "1st Meeting",
            children: [
                { title: "GPs Conducted", dataIndex: "m1_conducted", align: "center", width: 120, sorter: (a, b) => numberSorter(a, b, 'm1_conducted') },
                { title: "GPs Updated (Voters, MOM, Attendance)", dataIndex: "m1_updated", align: "center", width: 200, sorter: (a, b) => numberSorter(a, b, 'm1_updated') },
                { title: "Quorum Fulfilled", dataIndex: "m1_quorum_yes", align: "center", width: 130, sorter: (a, b) => numberSorter(a, b, 'm1_quorum_yes') },
                { title: "Quorum Failed", dataIndex: "m1_quorum_no", align: "center", width: 130, sorter: (a, b) => numberSorter(a, b, 'm1_quorum_no') },
            ],
        },

        /* -------- 2nd Meeting -------- */
        {
            title: "2nd Meeting",
            children: [
                { title: "GPs Conducted", dataIndex: "m2_conducted", align: "center", width: 120, sorter: (a, b) => numberSorter(a, b, 'm2_conducted') },
                { title: "GPs Updated (Voters, MOM, Attendance)", dataIndex: "m2_updated", align: "center", width: 200, sorter: (a, b) => numberSorter(a, b, 'm2_updated') },
                { title: "Quorum Fulfilled", dataIndex: "m2_quorum_yes", align: "center", width: 130, sorter: (a, b) => numberSorter(a, b, 'm2_quorum_yes') },
                { title: "Quorum Failed", dataIndex: "m2_quorum_no", align: "center", width: 130, sorter: (a, b) => numberSorter(a, b, 'm2_quorum_no') },
            ],
        },

        /* -------- 3rd Meeting -------- */
        {
            title: "3rd Meeting",
            children: [
                { title: "GPs Conducted", dataIndex: "m3_conducted", align: "center", width: 120, sorter: (a, b) => numberSorter(a, b, 'm3_conducted') },
                { title: "GPs Updated (Voters, MOM, Attendance)", dataIndex: "m3_updated", align: "center", width: 200, sorter: (a, b) => numberSorter(a, b, 'm3_updated') },
                { title: "Quorum Fulfilled", dataIndex: "m3_quorum_yes", align: "center", width: 130, sorter: (a, b) => numberSorter(a, b, 'm3_quorum_yes') },
                { title: "Quorum Failed", dataIndex: "m3_quorum_no", align: "center", width: 130, sorter: (a, b) => numberSorter(a, b, 'm3_quorum_no') },
            ],
        },


        {
            title: "Never Rescheduled (Failed in 1st Meeting)",
            dataIndex: "never_rescheduled",
            align: "center",
            width: 200,
            sorter: (a, b) => numberSorter(a, b, 'never_rescheduled'),
        },
    ];

    /* ================= BLOCK MODAL COLUMNS ================= */
    const blockColumns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            width: 60,
            align: "center",
            fixed: "left",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
        },
        {
            title: "District Name",
            dataIndex: "district_name",
            width: 140,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),
        },
        {
            title: "Block Name",
            dataIndex: "block_name",
            width: 180,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'block_name'),
        },
        {
            title: "No. of Gram Panchayats",
            dataIndex: "no_of_gram_panchayats",
            width: 150,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'no_of_gram_panchayats'),
            render: (value, record) => (
                <span onClick={() => openGPFromBlock(record)} style={clickStyle}>
                    {value || 0}
                </span>
            ),
        },
        {
            title: "1st Meeting - GPs Conducted",
            dataIndex: "m1_conducted",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm1_conducted'),
        },
        {
            title: "1st Meeting - GPs Updated",
            dataIndex: "m1_updated",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm1_updated'),
        },
        {
            title: "1st Meeting - Quorum Yes",
            dataIndex: "m1_quorum_yes",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm1_quorum_yes'),
        },
        {
            title: "1st Meeting - Quorum No",
            dataIndex: "m1_quorum_no",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm1_quorum_no'),
        },
        {
            title: "2nd Meeting - GPs Conducted",
            dataIndex: "m2_conducted",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm2_conducted'),
        },
        {
            title: "2nd Meeting - GPs Updated",
            dataIndex: "m2_updated",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm2_updated'),
        },
        {
            title: "2nd Meeting - Quorum Yes",
            dataIndex: "m2_quorum_yes",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm2_quorum_yes'),
        },
        {
            title: "2nd Meeting - Quorum No",
            dataIndex: "m2_quorum_no",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm2_quorum_no'),
        },
        {
            title: "3rd Meeting - GPs Conducted",
            dataIndex: "m3_conducted",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm3_conducted'),
        },
        {
            title: "3rd Meeting - GPs Updated",
            dataIndex: "m3_updated",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm3_updated'),
        },
        {
            title: "3rd Meeting - Quorum Yes",
            dataIndex: "m3_quorum_yes",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm3_quorum_yes'),
        },
        {
            title: "3rd Meeting - Quorum No",
            dataIndex: "m3_quorum_no",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm3_quorum_no'),
        },
        {
            title: "Never Rescheduled",
            dataIndex: "never_rescheduled",
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'never_rescheduled'),
        },
    ];

    /* ================= GP MODAL COLUMNS ================= */
    const gpColumns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            width: 60,
            align: "center",
            fixed: "left",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
        },
        {
            title: "District Name",
            dataIndex: "district_name",
            width: 120,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),
        },
        {
            title: "Block Name",
            dataIndex: "block_name",
            width: 140,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'block_name'),
        },
        {
            title: "Gram Panchayat Name",
            dataIndex: "gp_name",
            width: 200,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'gp_name'),
        },
        {
            title: "1st Meeting - Conducted",
            dataIndex: "m1_conducted",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm1_conducted'),
        },
        {
            title: "1st Meeting - Updated",
            dataIndex: "m1_updated",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm1_updated'),
        },
        {
            title: "1st Meeting - Quorum Yes",
            dataIndex: "m1_quorum_yes",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm1_quorum_yes'),
        },
        {
            title: "1st Meeting - Quorum No",
            dataIndex: "m1_quorum_no",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm1_quorum_no'),
        },
        {
            title: "2nd Meeting - Conducted",
            dataIndex: "m2_conducted",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm2_conducted'),
        },
        {
            title: "2nd Meeting - Updated",
            dataIndex: "m2_updated",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm2_updated'),
        },
        {
            title: "2nd Meeting - Quorum Yes",
            dataIndex: "m2_quorum_yes",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm2_quorum_yes'),
        },
        {
            title: "2nd Meeting - Quorum No",
            dataIndex: "m2_quorum_no",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm2_quorum_no'),
        },
        {
            title: "3rd Meeting - Conducted",
            dataIndex: "m3_conducted",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm3_conducted'),
        },
        {
            title: "3rd Meeting - Updated",
            dataIndex: "m3_updated",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm3_updated'),
        },
        {
            title: "3rd Meeting - Quorum Yes",
            dataIndex: "m3_quorum_yes",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm3_quorum_yes'),
        },
        {
            title: "3rd Meeting - Quorum No",
            dataIndex: "m3_quorum_no",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'm3_quorum_no'),
        },
        {
            title: "Never Rescheduled",
            dataIndex: "never_rescheduled",
            width: 130,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'never_rescheduled'),
        },
    ];

    /* ================= FETCH DATA ================= */
    useEffect(() => {
        fetchReport(dateFilter);
    }, [dateFilter]);

    const fetchReport = async (currentDateFilter) => {
        try {
            setLoading(true);
            setError(null);

            const token = sessionStorage.getItem("token");

            const res = await getCeoDistrictwiseGSCompliance(token, currentDateFilter);

            const formatted = res.result.map((row, index) => ({
                key: index + 1,
                sr_no: index + 1,
                ...row,
            }));

            setData(formatted);

        } catch (err) {
            setError(err.message);
            message.error(err.message);
        } finally {
            setLoading(false);
        }
    };

    /* ================= DRILL FUNCTIONS ================= */
    const openBlockModal = async (district) => {
        console.log('Opening block modal for district:', district.district_name);
        setBlockModalTitle(`Block-wise GS Compliance Report : ${district.district_name}`);
        setBlockModalOpen(true);
        setBlockData([]);
        setBlockLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setBlockLoading(false);
                return;
            }

            console.log('Fetching block summary for district:', district.district_code);
            const result = await getBlockwiseGSComplianceCEO(token, district.district_code);

            console.log("Block summary result:", result);

            if (result.success) {
                const blockFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: `${item.district_code}_${item.block_code}` || index + 1,
                    sr_no: index + 1,
                    district_name: item.district_name || district.district_name,
                    block_name: item.block_name,
                    block_code: item.block_code,
                    // Map the compliance data fields
                    no_of_gram_panchayats: item.gp_count || 0,
                    m1_conducted: item.m1_conducted || 0,
                    m1_updated: item.m1_updated || 0,
                    m1_quorum_yes: item.m1_quorum_yes || 0,
                    m1_quorum_no: item.m1_quorum_no || 0,
                    m2_conducted: item.m2_conducted || 0,
                    m2_updated: item.m2_updated || 0,
                    m2_quorum_yes: item.m2_quorum_yes || 0,
                    m2_quorum_no: item.m2_quorum_no || 0,
                    m3_conducted: item.m3_conducted || 0,
                    m3_updated: item.m3_updated || 0,
                    m3_quorum_yes: item.m3_quorum_yes || 0,
                    m3_quorum_no: item.m3_quorum_no || 0,
                    never_rescheduled: item.never_rescheduled || 0,
                }));

                console.log("Formatted block data:", blockFormatted);
                setBlockData(blockFormatted);
                message.success(`Loaded ${blockFormatted.length} blocks`);
            } else {
                message.error(result.message || 'Failed to fetch block data');
            }
        } catch (err) {
            console.error('Error fetching block data:', err);
            message.error(err.message || 'Failed to fetch block data');
        } finally {
            setBlockLoading(false);
        }
    };

    const openGPFromDistrict = async (district) => {
        console.log('Opening GP modal for district:', district.district_name);
        setGpModalTitle(`Gram Panchayat-wise GS Compliance Report : ${district.district_name}`);
        setGpModalOpen(true);
        setGpData([]);
        setGpLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setGpLoading(false);
                return;
            }

            const result = await getGPwiseGSComplianceCEO(token, district.district_code);

            if (result.success) {
                const gpFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: item.panchayat_code || `gp-${index}`,
                    sr_no: index + 1,
                    district_name: item.district_name,
                    block_name: item.block_name,
                    gp_name: item.panchayat_name || item.gp_name,
                    block_code: item.block_code,
                    panchayat_code: item.panchayat_code,
                    // Map the compliance data fields
                    m1_conducted: item.m1_conducted || 0,
                    m1_updated: item.m1_updated || 0,
                    m1_quorum_yes: item.m1_quorum_yes || 0,
                    m1_quorum_no: item.m1_quorum_no || 0,
                    m2_conducted: item.m2_conducted || 0,
                    m2_updated: item.m2_updated || 0,
                    m2_quorum_yes: item.m2_quorum_yes || 0,
                    m2_quorum_no: item.m2_quorum_no || 0,
                    m3_conducted: item.m3_conducted || 0,
                    m3_updated: item.m3_updated || 0,
                    m3_quorum_yes: item.m3_quorum_yes || 0,
                    m3_quorum_no: item.m3_quorum_no || 0,
                    never_rescheduled: item.never_rescheduled || 0,
                }));

                setGpData(gpFormatted);
                message.success(`Loaded ${gpFormatted.length} gram panchayats for ${district.district_name}`);
            } else {
                message.error(result.message || 'Failed to fetch GP data');
            }
        } catch (err) {
            console.error('Error fetching GP data:', err);
            message.error(err.message || 'Failed to fetch GP data');
        } finally {
            setGpLoading(false);
        }
    };

    const openGPFromBlock = async (block) => {
        setBlockModalOpen(false);
        console.log('Opening GP modal for block:', block.block_name);
        setGpModalTitle(`Gram Panchayat-wise GS Compliance Report : ${block.block_name} (${block.district_name})`);
        setGpModalOpen(true);
        setGpData([]);
        setGpLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setGpLoading(false);
                return;
            }

            const result = await getGPwiseGSComplianceCEO(token, block.district_code, block.block_code);

            if (result.success) {
                const gpFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: item.panchayat_code || `gp-${index}`,
                    sr_no: index + 1,
                    district_name: item.district_name,
                    block_name: item.block_name,
                    gp_name: item.panchayat_name || item.gp_name,
                    block_code: item.block_code,
                    panchayat_code: item.panchayat_code,
                    // Map the compliance data fields
                    m1_conducted: item.m1_conducted || 0,
                    m1_updated: item.m1_updated || 0,
                    m1_quorum_yes: item.m1_quorum_yes || 0,
                    m1_quorum_no: item.m1_quorum_no || 0,
                    m2_conducted: item.m2_conducted || 0,
                    m2_updated: item.m2_updated || 0,
                    m2_quorum_yes: item.m2_quorum_yes || 0,
                    m2_quorum_no: item.m2_quorum_no || 0,
                    m3_conducted: item.m3_conducted || 0,
                    m3_updated: item.m3_updated || 0,
                    m3_quorum_yes: item.m3_quorum_yes || 0,
                    m3_quorum_no: item.m3_quorum_no || 0,
                    never_rescheduled: item.never_rescheduled || 0,
                }));

                setGpData(gpFormatted);
                message.success(`Loaded ${gpFormatted.length} gram panchayats for ${block.block_name}`);
            } else {
                message.error(result.message || 'Failed to fetch GP data');
            }
        } catch (err) {
            console.error('Error fetching GP data:', err);
            message.error(err.message || 'Failed to fetch GP data');
        } finally {
            setGpLoading(false);
        }
    };


    /* ================= EXPORT PDF ================= */
    const handleExportPDF = () => {
        if (!data.length) return message.warning("No data to export");

        try {
            const doc = new jsPDF("landscape");

            // Title
            doc.setFontSize(18);
            doc.setTextColor(40, 40, 40);
            doc.text("Districtwise Special Gram Sabha Meeting Compliance", 148, 20, { align: 'center' });

            // Prepare headers - handle nested columns
            const flatColumns = columns.flatMap(col =>
                col.children ? col.children : col
            );

            const mainHeaders = flatColumns.map(col => col.title);


            // Prepare data rows
            const tableRows = data.map(row =>
                flatColumns.map(col => row[col.dataIndex] ?? '')
            );


            // Add GRAND TOTAL ROW
            // Add GRAND TOTAL ROW (dynamic — fixes column mismatch)
            const grandTotalRow = flatColumns.map(col => {
                if (col.dataIndex === "district_name") return "GRAND TOTAL";
                if (col.dataIndex === "sr_no") return "";
                return mainTotals[col.dataIndex] ?? "";
            });

            tableRows.push(grandTotalRow);




            autoTable(doc, {
                head: [mainHeaders],
                body: tableRows,
                startY: 30,
                theme: 'grid',
                headStyles: {
                    fillColor: [22, 119, 255],
                    textColor: 255,
                    fontStyle: 'bold',
                    fontSize: 8
                },
                styles: {
                    fontSize: 7,
                    cellPadding: 2,
                    overflow: 'linebreak',
                    halign: 'center'
                },
                columnStyles: {
                    0: { cellWidth: 15 },
                    1: { cellWidth: 40, halign: 'left' }
                },
                didParseCell: function (data) {
                    // Style for grand total row
                    if (data.row.index === tableRows.length - 1) {
                        data.cell.styles.fillColor = [240, 249, 255];
                        data.cell.styles.fontStyle = 'bold';
                        data.cell.styles.textColor = [0, 0, 0];
                    }
                }
            });

            // Add generation timestamp
            const today = new Date();
            const dateStr = today.toLocaleDateString('en-IN', {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit'
            });

            doc.setFontSize(8);
            doc.setTextColor(100, 100, 100);
            doc.text(`Generated on: ${dateStr}`, 280, doc.lastAutoTable.finalY + 10, { align: 'right' });

            doc.save(`Districtwise_GS_Compliance_${new Date().toISOString().split('T')[0]}.pdf`);
            message.success("PDF exported successfully with grand totals");
        } catch (err) {
            console.error("PDF Export Error:", err);
            message.error("Failed to export PDF: " + err.message);
        }
    };
    /* ================= EXPORT EXCEL ================= */
    const handleExportExcel = () => {
        if (!data.length) return message.warning("No data to export");

        try {
            const excelData = data.map((row, idx) => ({
                "Sr. No.": idx + 1,
                "District": row.district_name || "-",
                "No. of Blocks": row.block_count || 0,
                "No. of GPs": row.gp_count || 0,
                "1st Conducted": row.m1_conducted || 0,
                "1st Updated": row.m1_updated || 0,
                "1st Quorum Yes": row.m1_quorum_yes || 0,
                "1st Quorum No": row.m1_quorum_no || 0,
                "2nd Conducted": row.m2_conducted || 0,
                "2nd Updated": row.m2_updated || 0,
                "2nd Quorum Yes": row.m2_quorum_yes || 0,
                "2nd Quorum No": row.m2_quorum_no || 0,
                "3rd Conducted": row.m3_conducted || 0,
                "3rd Updated": row.m3_updated || 0,
                "3rd Quorum Yes": row.m3_quorum_yes || 0,
                "3rd Quorum No": row.m3_quorum_no || 0,
                "Never Rescheduled": row.never_rescheduled || 0,
            }));

            // Add GRAND TOTAL ROW
            excelData.push({
                "Sr. No.": "",
                "District": "GRAND TOTAL",
                "No. of Blocks": mainTotals.block_count,
                "No. of GPs": mainTotals.gp_count,
                "1st Conducted": mainTotals.m1_conducted,
                "1st Updated": mainTotals.m1_updated,
                "1st Quorum Yes": mainTotals.m1_quorum_yes,
                "1st Quorum No": mainTotals.m1_quorum_no,
                "2nd Conducted": mainTotals.m2_conducted,
                "2nd Updated": mainTotals.m2_updated,
                "2nd Quorum Yes": mainTotals.m2_quorum_yes,
                "2nd Quorum No": mainTotals.m2_quorum_no,
                "3rd Conducted": mainTotals.m3_conducted,
                "3rd Updated": mainTotals.m3_updated,
                "3rd Quorum Yes": mainTotals.m3_quorum_yes,
                "3rd Quorum No": mainTotals.m3_quorum_no,
                "Never Rescheduled": mainTotals.never_rescheduled,
            });

            const ws = XLSX.utils.json_to_sheet(excelData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Compliance Report");
            XLSX.writeFile(wb, `Districtwise_GS_Compliance_${new Date().toISOString().split('T')[0]}.xlsx`);
            message.success("Excel file exported successfully with grand totals");
        } catch (err) {
            console.error("Excel Export Error:", err);
            message.error("Failed to export Excel");
        }
    };

    /* ================= EXPORT BLOCK EXCEL ================= */
    const handleExportBlockExcel = () => {
        if (!blockData.length) return message.warning("No data to export");

        try {
            const excelData = blockData.map((row, idx) => ({
                "Sr. No.": idx + 1,
                "District Name": row.district_name || "-",
                "Block Name": row.block_name || "-",
                "No. of Gram Panchayats": row.no_of_gram_panchayats || 0,
                "1st Meeting - Conducted": row.m1_conducted || 0,
                "1st Meeting - Updated": row.m1_updated || 0,
                "1st Meeting - Quorum Yes": row.m1_quorum_yes || 0,
                "1st Meeting - Quorum No": row.m1_quorum_no || 0,
                "2nd Meeting - Conducted": row.m2_conducted || 0,
                "2nd Meeting - Updated": row.m2_updated || 0,
                "2nd Meeting - Quorum Yes": row.m2_quorum_yes || 0,
                "2nd Meeting - Quorum No": row.m2_quorum_no || 0,
                "3rd Meeting - Conducted": row.m3_conducted || 0,
                "3rd Meeting - Updated": row.m3_updated || 0,
                "3rd Meeting - Quorum Yes": row.m3_quorum_yes || 0,
                "3rd Meeting - Quorum No": row.m3_quorum_no || 0,
                "Never Rescheduled": row.never_rescheduled || 0,
            }));

            // Add GRAND TOTAL ROW
            excelData.push({
                "Sr. No.": "",
                "District Name": "GRAND TOTAL",
                "Block Name": "",
                "No. of Gram Panchayats": blockTotals.no_of_gram_panchayats,
                "1st Meeting - Conducted": blockTotals.m1_conducted,
                "1st Meeting - Updated": blockTotals.m1_updated,
                "1st Meeting - Quorum Yes": blockTotals.m1_quorum_yes,
                "1st Meeting - Quorum No": blockTotals.m1_quorum_no,
                "2nd Meeting - Conducted": blockTotals.m2_conducted,
                "2nd Meeting - Updated": blockTotals.m2_updated,
                "2nd Meeting - Quorum Yes": blockTotals.m2_quorum_yes,
                "2nd Meeting - Quorum No": blockTotals.m2_quorum_no,
                "3rd Meeting - Conducted": blockTotals.m3_conducted,
                "3rd Meeting - Updated": blockTotals.m3_updated,
                "3rd Meeting - Quorum Yes": blockTotals.m3_quorum_yes,
                "3rd Meeting - Quorum No": blockTotals.m3_quorum_no,
                "Never Rescheduled": blockTotals.never_rescheduled,
            });

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Block GS Compliance");

            const fileName = `Block_GS_Compliance_${new Date().toISOString().split('T')[0]}.xlsx`;
            XLSX.writeFile(workbook, fileName);
            message.success("Block Excel file exported successfully with grand totals");
        } catch (err) {
            console.error("Block Excel Export Error:", err);
            message.error("Failed to export Block Excel");
        }
    };

    /* ================= EXPORT GP EXCEL ================= */
    const handleExportGpExcel = () => {
        if (!gpData.length) return message.warning("No data to export");

        try {
            const excelData = gpData.map((row, idx) => ({
                "Sr. No.": idx + 1,
                "District Name": row.district_name || "-",
                "Block Name": row.block_name || "-",
                "Gram Panchayat Name": row.gp_name || "-",
                "1st Meeting - Conducted": row.m1_conducted || 0,
                "1st Meeting - Updated": row.m1_updated || 0,
                "1st Meeting - Quorum Yes": row.m1_quorum_yes || 0,
                "1st Meeting - Quorum No": row.m1_quorum_no || 0,
                "2nd Meeting - Conducted": row.m2_conducted || 0,
                "2nd Meeting - Updated": row.m2_updated || 0,
                "2nd Meeting - Quorum Yes": row.m2_quorum_yes || 0,
                "2nd Meeting - Quorum No": row.m2_quorum_no || 0,
                "3rd Meeting - Conducted": row.m3_conducted || 0,
                "3rd Meeting - Updated": row.m3_updated || 0,
                "3rd Meeting - Quorum Yes": row.m3_quorum_yes || 0,
                "3rd Meeting - Quorum No": row.m3_quorum_no || 0,
                "Never Rescheduled": row.never_rescheduled || 0,
            }));

            // Add GRAND TOTAL ROW
            excelData.push({
                "Sr. No.": "",
                "District Name": "GRAND TOTAL",
                "Block Name": "",
                "Gram Panchayat Name": "",
                "1st Meeting - Conducted": gpTotals.m1_conducted,
                "1st Meeting - Updated": gpTotals.m1_updated,
                "1st Meeting - Quorum Yes": gpTotals.m1_quorum_yes,
                "1st Meeting - Quorum No": gpTotals.m1_quorum_no,
                "2nd Meeting - Conducted": gpTotals.m2_conducted,
                "2nd Meeting - Updated": gpTotals.m2_updated,
                "2nd Meeting - Quorum Yes": gpTotals.m2_quorum_yes,
                "2nd Meeting - Quorum No": gpTotals.m2_quorum_no,
                "3rd Meeting - Conducted": gpTotals.m3_conducted,
                "3rd Meeting - Updated": gpTotals.m3_updated,
                "3rd Meeting - Quorum Yes": gpTotals.m3_quorum_yes,
                "3rd Meeting - Quorum No": gpTotals.m3_quorum_no,
                "Never Rescheduled": gpTotals.never_rescheduled,
            });

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "GP GS Compliance");

            const fileName = `GP_GS_Compliance_${new Date().toISOString().split('T')[0]}.xlsx`;
            XLSX.writeFile(workbook, fileName);
            message.success("GP Excel file exported successfully with grand totals");
        } catch (err) {
            console.error("GP Excel Export Error:", err);
            message.error("Failed to export GP Excel");
        }
    };


    /* ================= BLOCK MODAL GRAND TOTALS ================= */
    const blockTotals = {
        no_of_gram_panchayats: blockData.reduce((s, i) => s + (i.no_of_gram_panchayats || 0), 0),
        m1_conducted: blockData.reduce((s, i) => s + (i.m1_conducted || 0), 0),
        m1_updated: blockData.reduce((s, i) => s + (i.m1_updated || 0), 0),
        m1_quorum_yes: blockData.reduce((s, i) => s + (i.m1_quorum_yes || 0), 0),
        m1_quorum_no: blockData.reduce((s, i) => s + (i.m1_quorum_no || 0), 0),
        m2_conducted: blockData.reduce((s, i) => s + (i.m2_conducted || 0), 0),
        m2_updated: blockData.reduce((s, i) => s + (i.m2_updated || 0), 0),
        m2_quorum_yes: blockData.reduce((s, i) => s + (i.m2_quorum_yes || 0), 0),
        m2_quorum_no: blockData.reduce((s, i) => s + (i.m2_quorum_no || 0), 0),
        m3_conducted: blockData.reduce((s, i) => s + (i.m3_conducted || 0), 0),
        m3_updated: blockData.reduce((s, i) => s + (i.m3_updated || 0), 0),
        m3_quorum_yes: blockData.reduce((s, i) => s + (i.m3_quorum_yes || 0), 0),
        m3_quorum_no: blockData.reduce((s, i) => s + (i.m3_quorum_no || 0), 0),
        never_rescheduled: blockData.reduce((s, i) => s + (i.never_rescheduled || 0), 0),
    };
    /* ================= GP MODAL GRAND TOTALS ================= */
    const gpTotals = {
        m1_conducted: gpData.reduce((s, i) => s + (i.m1_conducted || 0), 0),
        m1_updated: gpData.reduce((s, i) => s + (i.m1_updated || 0), 0),
        m1_quorum_yes: gpData.reduce((s, i) => s + (i.m1_quorum_yes || 0), 0),
        m1_quorum_no: gpData.reduce((s, i) => s + (i.m1_quorum_no || 0), 0),
        m2_conducted: gpData.reduce((s, i) => s + (i.m2_conducted || 0), 0),
        m2_updated: gpData.reduce((s, i) => s + (i.m2_updated || 0), 0),
        m2_quorum_yes: gpData.reduce((s, i) => s + (i.m2_quorum_yes || 0), 0),
        m2_quorum_no: gpData.reduce((s, i) => s + (i.m2_quorum_no || 0), 0),
        m3_conducted: gpData.reduce((s, i) => s + (i.m3_conducted || 0), 0),
        m3_updated: gpData.reduce((s, i) => s + (i.m3_updated || 0), 0),
        m3_quorum_yes: gpData.reduce((s, i) => s + (i.m3_quorum_yes || 0), 0),
        m3_quorum_no: gpData.reduce((s, i) => s + (i.m3_quorum_no || 0), 0),
        never_rescheduled: gpData.reduce((s, i) => s + (i.never_rescheduled || 0), 0),
    };

    return (
        <div style={{ padding: 24, background: "#f0f2f5", minHeight: "100vh" }}>
            <div
                style={{
                    background: "#fff",
                    padding: 24,
                    borderRadius: 8,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                }}
            >

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 20,
                    }}
                >
                    <div>
                        <h2 style={{ fontSize: 20, fontWeight: 600, color: "#1f1f1f" }}>
                            Districtwise Special Gram Sabha Meeting Compliance (CEO)
                        </h2>
                        <p style={{ margin: 0, color: "#666" }}>
                            Total Records: <strong>{data.length}</strong>
                        </p>
                    </div>

                    <Space>
                        <Button icon={<FilePdfOutlined />} onClick={handleExportPDF}>
                            Export PDF
                        </Button>
                        <Button type="primary" icon={<FileExcelOutlined />} onClick={handleExportExcel}>
                            Export Excel
                        </Button>
                        <Button icon={<ReloadOutlined />} onClick={() => fetchReport(dateFilter)}>
                            Refresh
                        </Button>
                    </Space>
                </div>


                {error && <Alert message={error} type="error" showIcon />}

                {loading ? (
                    <Spin size="large" />
                ) : (
                    <Table
                        columns={columns}
                        dataSource={data}
                        bordered
                        size="small"
                        scroll={{ x: 2400, y: 420 }}
                        pagination={{
                            current: currentPage,
                            pageSize,
                            total: data.length,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} records`,
                        }}
                        onChange={(pagination) => {
                            setCurrentPage(pagination.current);
                            setPageSize(pagination.pageSize);
                        }}
                    />

                )}
                {data.length > 0 && (
                    <div
                        style={{
                            marginTop: 12,
                            padding: "10px 14px",
                            background: "#e6f7ff",
                            border: "1px solid #91d5ff",
                            borderRadius: 6,
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 12,
                            fontSize: 12,
                        }}
                    >

                        <span><b>Grand Totals:</b></span>

                        <span>Blocks: <strong>{mainTotals.block_count}</strong></span>
                        <span>GPs: <strong>{mainTotals.gp_count}</strong></span>

                        <span>1st Conducted: <strong>{mainTotals.m1_conducted}</strong></span>
                        <span>1st Updated: <strong>{mainTotals.m1_updated}</strong></span>
                        <span>1st Quorum Yes: <strong>{mainTotals.m1_quorum_yes}</strong></span>
                        <span>1st Quorum No: <strong>{mainTotals.m1_quorum_no}</strong></span>

                        <span>2nd Conducted: <strong>{mainTotals.m2_conducted}</strong></span>
                        <span>2nd Updated: <strong>{mainTotals.m2_updated}</strong></span>
                        <span>2nd Quorum Yes: <strong>{mainTotals.m2_quorum_yes}</strong></span>
                        <span>2nd Quorum No: <strong>{mainTotals.m2_quorum_no}</strong></span>

                        <span>3rd Conducted: <strong>{mainTotals.m3_conducted}</strong></span>
                        <span>3rd Updated: <strong>{mainTotals.m3_updated}</strong></span>
                        <span>3rd Quorum Yes: <strong>{mainTotals.m3_quorum_yes}</strong></span>
                        <span>3rd Quorum No: <strong>{mainTotals.m3_quorum_no}</strong></span>

                        <span>Never Rescheduled: <strong>{mainTotals.never_rescheduled}</strong></span>

                    </div>
                )}



                {/* ========== BLOCK MODAL ========== */}
                <Modal
                    open={blockModalOpen}
                    onCancel={() => setBlockModalOpen(false)}
                    width={1400}
                    destroyOnClose
                    footer={null}
                    closable
                    style={{ top: 20 }}
                    bodyStyle={{
                        padding: '16px 0 0 0',
                        overflow: 'hidden'
                    }}
                    title={
                        <div style={{ paddingRight: 40 }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <span style={{ fontSize: "16px", fontWeight: "600", color: "#1f1f1f" }}>
                                    {blockModalTitle}
                                </span>

                                <Button
                                    type="primary"
                                    icon={<FileExcelOutlined />}
                                    onClick={handleExportBlockExcel}
                                    disabled={blockLoading || blockData.length === 0}
                                    style={{ fontWeight: 500 }}
                                >
                                    Export Excel
                                </Button>
                            </div>
                        </div>
                    }
                >
                    {blockLoading ? (
                        <div style={{ textAlign: "center", padding: "40px" }}>
                            <Spin size="large" />
                            <p style={{ marginTop: 10, color: "#666", fontWeight: 500 }}>
                                Loading block data...
                            </p>
                        </div>
                    ) : blockData.length === 0 ? (
                        <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
                            <Alert
                                message={<span style={{ fontWeight: 600 }}>No Data Available</span>}
                                description={
                                    <span style={{ fontWeight: 500 }}>
                                        No block data found for this district. Please check if the district
                                        has any blocks assigned.
                                    </span>
                                }
                                type="info"
                                showIcon
                            />
                        </div>
                    ) : (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: 'calc(80vh - 110px)',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                flex: 1,
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                paddingRight: '4px'
                            }}>
                                <Table
                                    columns={blockColumns}
                                    dataSource={blockData}
                                    rowKey="key"
                                    bordered
                                    size="small"
                                    scroll={{
                                        x: 1800,
                                        y: undefined
                                    }}
                                    pagination={{
                                        current: blockCurrentPage,
                                        pageSize: blockPageSize,
                                        total: blockData.length,
                                        showSizeChanger: true,
                                        pageSizeOptions: ['10', '20', '50', '100'],
                                        showTotal: (total, range) =>
                                            `${range[0]}-${range[1]} of ${total} blocks`,
                                    }}
                                    onChange={(pagination) => {
                                        setBlockCurrentPage(pagination.current);
                                        setBlockPageSize(pagination.pageSize);
                                    }}
                                />
                            </div>

                            <div
                                style={{
                                    marginTop: 12,
                                    padding: "10px 14px",
                                    background: "#e6f7ff",
                                    border: "1px solid #91d5ff",
                                    borderRadius: 6,
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 12,
                                    fontSize: 12,
                                }}
                            >


                                <span><b>Grand Totals:</b></span>

                                <span>GPs: <strong>{blockTotals.no_of_gram_panchayats}</strong></span>

                                <span>1st Conducted: <strong>{blockTotals.m1_conducted}</strong></span>
                                <span>1st Updated: <strong>{blockTotals.m1_updated}</strong></span>
                                <span>1st Quorum Yes: <strong>{blockTotals.m1_quorum_yes}</strong></span>
                                <span>1st Quorum No: <strong>{blockTotals.m1_quorum_no}</strong></span>

                                <span>2nd Conducted: <strong>{blockTotals.m2_conducted}</strong></span>
                                <span>2nd Updated: <strong>{blockTotals.m2_updated}</strong></span>
                                <span>2nd Quorum Yes: <strong>{blockTotals.m2_quorum_yes}</strong></span>
                                <span>2nd Quorum No: <strong>{blockTotals.m2_quorum_no}</strong></span>

                                <span>3rd Conducted: <strong>{blockTotals.m3_conducted}</strong></span>
                                <span>3rd Updated: <strong>{blockTotals.m3_updated}</strong></span>
                                <span>3rd Quorum Yes: <strong>{blockTotals.m3_quorum_yes}</strong></span>
                                <span>3rd Quorum No: <strong>{blockTotals.m3_quorum_no}</strong></span>

                                <span>Never Rescheduled: <strong>{blockTotals.never_rescheduled}</strong></span>

                            </div>

                        </div>
                    )}
                </Modal>

                {/* ========== GP MODAL ========== */}
                <Modal
                    open={gpModalOpen}
                    onCancel={() => setGpModalOpen(false)}
                    width={1400}
                    destroyOnClose
                    footer={null}
                    closable
                    style={{ top: 20 }}
                    bodyStyle={{
                        padding: '16px 0 0 0',
                        overflow: 'hidden'
                    }}
                    title={
                        <div style={{ paddingRight: 40 }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <span style={{ fontSize: "16px", fontWeight: "600", color: "#1f1f1f" }}>
                                    {gpModalTitle}
                                </span>

                                <Button
                                    type="primary"
                                    icon={<FileExcelOutlined />}
                                    onClick={handleExportGpExcel}
                                    disabled={gpLoading || gpData.length === 0}
                                    style={{ fontWeight: 500 }}
                                >
                                    Export Excel
                                </Button>
                            </div>
                        </div>
                    }
                >
                    {gpLoading ? (
                        <div style={{ textAlign: "center", padding: "40px" }}>
                            <Spin size="large" />
                            <p style={{ marginTop: 10, color: "#666", fontWeight: 500 }}>
                                Loading Gram Panchayat data...
                            </p>
                        </div>
                    ) : (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: 'calc(80vh - 110px)',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                flex: 1,
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                paddingRight: '4px'
                            }}>
                                <Table
                                    columns={gpColumns}
                                    dataSource={gpData}
                                    rowKey="key"
                                    bordered
                                    size="small"
                                    scroll={{
                                        x: 1600,
                                        y: undefined
                                    }}
                                    pagination={{
                                        current: gpCurrentPage,
                                        pageSize: gpPageSize,
                                        total: gpData.length,
                                        showSizeChanger: true,
                                        pageSizeOptions: ['10', '20', '50', '100'],
                                        showTotal: (total, range) =>
                                            `${range[0]}-${range[1]} of ${total} GPs`,
                                    }}
                                    onChange={(pagination) => {
                                        setGpCurrentPage(pagination.current);
                                        setGpPageSize(pagination.pageSize);
                                    }}
                                />
                            </div>

                            {/* 🔽 TOTAL STRIP BELOW TABLE */}
                            {gpData.length > 0 && (
                                <div
                                    style={{
                                        marginTop: 12,
                                        padding: "10px 14px",
                                        background: "#e6f7ff",
                                        border: "1px solid #91d5ff",
                                        borderRadius: 6,
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 12,
                                        fontSize: 12,
                                    }}
                                >
                                    <span><b>Grand Totals:</b></span>

                                    <span>1st Conducted: <strong>{gpTotals.m1_conducted}</strong></span>
                                    <span>1st Updated: <strong>{gpTotals.m1_updated}</strong></span>
                                    <span>1st Quorum Yes: <strong>{gpTotals.m1_quorum_yes}</strong></span>
                                    <span>1st Quorum No: <strong>{gpTotals.m1_quorum_no}</strong></span>

                                    <span>2nd Conducted: <strong>{gpTotals.m2_conducted}</strong></span>
                                    <span>2nd Updated: <strong>{gpTotals.m2_updated}</strong></span>
                                    <span>2nd Quorum Yes: <strong>{gpTotals.m2_quorum_yes}</strong></span>
                                    <span>2nd Quorum No: <strong>{gpTotals.m2_quorum_no}</strong></span>

                                    <span>3rd Conducted: <strong>{gpTotals.m3_conducted}</strong></span>
                                    <span>3rd Updated: <strong>{gpTotals.m3_updated}</strong></span>
                                    <span>3rd Quorum Yes: <strong>{gpTotals.m3_quorum_yes}</strong></span>
                                    <span>3rd Quorum No: <strong>{gpTotals.m3_quorum_no}</strong></span>

                                    <span>Never Rescheduled: <strong>{gpTotals.never_rescheduled}</strong></span>

                                </div>
                            )}

                        </div>
                    )}
                </Modal>
            </div>
        </div>
    );
};

export default DistrictwiseSpecialGSComplianceCEO;
